import { render, staticRenderFns } from "./DoorOpenIcon.vue?vue&type=template&id=139425c7&scoped=true&"
import script from "./DoorOpenIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoorOpenIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139425c7",
  null
  
)

export default component.exports